import { DAY_IN_MS } from '../../../utils/time';

export const initialScore = 500;
export const BASE_ENERGY = 1000;
export const BASE_ENERGY_250 = 250;
export const BASE_ENERGY_500 = 500;
export const MAX_ADDITIONAL_ENERGY = 500;
export const AB0032_BASE_ENERGY = 50;
export const MAX_TAPS_PER_SECOND = 100;
export const PHOTO_FETCH_ATTEMPT_DELAY = DAY_IN_MS * 2;
export const PHOTO_REFRESH_DELAY = DAY_IN_MS * 7;
export const FALLBACK_PIC = 'fallback-pic';

export const TIKTOK_INITIAL_BALANCE = 5_000_000;
